module.exports = __webpack_public_path__ + "static/media/img-msg-pre-goal-mobile.5d7f0508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-msg-pre-goal-mobile.png
// module id = 1068
// module chunks = 0